import { Integer } from 'src/types/base';
import EnumStationType from 'src/enums/enumStationType';

/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 16:54 2021/10/16
 */

export interface MenuI {
    title: string;
    id: Integer;
    path: string;
    children?: MenuI[];
}
interface LayoutStateVOI {
    cache: string[];
    userInfo: UserManageDOI.QueryDetailResultI;
    menus: MenuI[];
    currentPageMenu: MenuI;
}

let state: LayoutStateVOI = {
    cache: [],
    userInfo: {
        id: 0,
        name: '',
        sex: false,
        idCard: '',
        phone: '',
        email: '',
        attachments: [],
        description: '',
        username: '',
        password: '',
        organizationId: null,
        organizationName: '',
        roleId: null,
        roleName: '',
        enabled: false,
    },

    menus: [
        {
            title: 'GIS地图',
            id: 1,
            path: '/gis/index',
        },
        {
            title: '污染源监测',
            path: '/pollution',
            id: 1,
            children: detectionMenus(EnumStationType.Pollution.getCode()),
        },
        {
            title: '地表水监测',
            path: '/water',
            id: 1,
            children: detectionMenusDbs(EnumStationType.Water.getCode()),
        },
        {
            title: '地下水监测',
            path: '/undergroundWater',
            id: 1,
            children: detectionMenus(EnumStationType.undergroundWater.getCode()),
        },
        {
            title: '运行维护',
            path: '/maintenanceManage',
            id: 1,
            children: [
                {
                    title: '运维申报',
                    path: '/maintenanceManage/declareMaintenance/index',
                    id: 1,
                },
                {
                    title: '运维审核',
                    path: '/maintenanceManage/declareMaintenance/audit',
                    id: 1,
                },
                {
                    title: '故障申报',
                    path: '/maintenanceManage/malfunctionManage/index',
                    id: 1,
                },
                {
                    title: '故障提交',
                    path: '/maintenanceManage/malfunctionManage/submit',
                    id: 1,
                },
                {
                    title: '故障审核',
                    path: '/maintenanceManage/malfunctionManage/audit',
                    id: 1,
                },
                {
                    title: '对比通知',
                    path: '/maintenanceManage/compareNotice/index',
                    id: 1,
                },
                {
                    title: '对比任务确认',
                    path: '/maintenanceManage/compareTaskConfirm/index',
                    id: 1,
                },
                {
                    title: '对比任务处理',
                    path: '/maintenanceManage/compareTaskConfirm/deal',
                    id: 1,
                },
                {
                    title: '异常通知',
                    path: '/maintenanceManage/compareException/index',
                    id: 1,
                },
                {
                    title: '异常任务派发',
                    path: '/maintenanceManage/exceptionTask/dispatch',
                    id: 1,
                },
                {
                    title: '异常任务处理',
                    path: '/maintenanceManage/exceptionTask/deal',
                    id: 1,
                },
                {
                    title: '运维统计',
                    path: '/maintenanceManage/maintenanceStatic/index',
                    id: 1,
                },
                {
                    title: '运维记录',
                    path: '/maintenanceManage/maintenanceRecord/index',
                    id: 1,
                },
                {
                    title: '原始报文',
                    path: '/maintenanceManage/original/message',
                    id: 1,
                },
                {
                    title: '软件密钥',
                    path: '/maintenanceManage/software/secretKey',
                    id: 1,
                },
                {
                    title: '藻类图片',
                    path: '/maintenanceManage/alga/picture',
                    id: 1,
                },
                {
                    title: '数据对接',
                    path: '/maintenanceManage/data/buttJoint',
                    id: 1,
                },
                {
                    title: '常见问题解决',
                    path: '/maintenanceManage',
                    id: 1,
                    children: [
                        {
                            title: '解决方案',
                            id: 1,
                            path: '/maintenanceManage/solution/index',
                        },
                        {
                            title: '操作记录',
                            path: '/maintenanceManage/operating/index',
                            id: 1,
                        },
                    ],
                },
            ],
        },
        {
            title: '系统设置',
            path: '/sass/systemConfig',
            id: 1,
            children: [
                {
                    title: '站点配置',
                    path: '/sass/systemConfig/stationConfig/index',
                    id: 1,
                },
                {
                    title: '用户配置',
                    path: '/sass/systemConfig/userConfig/index',
                    id: 1,
                },
                {
                    title: '单元配置',
                    path: '/sass/systemConfig/unitConfig/index',
                    id: 1,
                },
                {
                    title: '组织配置',
                    path: '/sass/systemConfig/organizationConfig/index',
                    id: 1,
                },
                {
                    title: '角色配置',
                    path: '/sass/systemConfig/roleConfig/index',
                    id: 1,
                },
                {
                    title: '视频密钥',
                    path: '/sass/systemConfig/video/secretKey',
                    id: 1,
                },
                {
                    title: '文件目录',
                    path: '/hexfile/index',
                    id: 1,
                },
                {
                    title: '离线下载器管理',
                    path: '/sn/index',
                    id: 1,
                },
                {
                    title: '其他sn管理',
                    path: '/elseSn/index',
                    id: 1,
                },
                {
                    title: '授权管理',
                    path: '/auth/index',
                    id: 1,
                },
                {
                    title: '授权记录',
                    path: '/authlog/index',
                    id: 1,
                },
                {
                    title: 'crc管理',
                    path: '/crc/index',
                    id: 1,
                },
                {
                    title: '角色资料管理',
                    path: '/roleDataCategories/index',
                    id: 1,
                },
                {
                    title: '应用市场',
                    path: '/applicationMarket/index',
                    id: 1,
                },
                {
                    title: '报警管理copy',
                    id: 1,
                    path: '/alarmManagecopy/index',
                },
                {
                    title: '大屏报表',
                    path: '/biscreen/index',
                    id: 1,
                },
                {
                    title: 'mn管控',
                    path: '/mnmanage/index',
                    id: 1,
                }
            ],
        },

        {
            title: '平台设置',
            path: '/platform/systemConfig',
            id: 1,
            children: [
                {
                    title: '用户配置',
                    path: '/platform/systemConfig/userConfig/index',
                    id: 1,
                },
                {
                    title: '组织配置',
                    path: '/platform/systemConfig/organizationConfig/index',
                    id: 1,
                },
                {
                    title: '角色配置',
                    path: '/platform/systemConfig/roleConfig/index',
                    id: 1,
                },
                {
                    title: 'Saas账号配置',
                    path: '/saasAccountConfig/index',
                    id: 1,
                },
                {
                    title: '反馈意见',
                    path: '/feedbackOpinion/index',
                    id: 1,
                },
            ],
        },
        {
            title: '系统信息',
            path: '/sass/systemMessage',
            id: 1,
            children: [
                {
                    title: '系统参数',
                    path: '/sass/systemMessage/systemParameter/index',
                    id: 1,
                },
                {
                    title: '系统日志',
                    path: '/sass/systemMessage/sysLog/index',
                    id: 1,
                },
                {
                    title: '系统反控',
                    path: '/sass/systemMessage/systemControl/index',
                    id: 1,
                },
                {
                    title: '系统设置',
                    path: '/sass/systemMessage/systemSet/index',
                    id: 1,
                },
                {
                    title: '数据查看',
                    path: '/sass/systemMessage/dataView/index',
                    id: 1,
                },
                {
                    title: '报警查询',
                    path: '/sass/systemMessage/alarmQuery/index',
                    id: 1,
                },
                {
                    title: '留样器日志',
                    path: '/sass/systemMessage/devLog/index',
                    id: 1,
                },
                {
                    title: '摄像头报警',
                    path: '/sass/systemMessage/cameraAlarm/index',
                    id: 1,
                },
            ],
        },
    ],
    currentPageMenu: { title: '', id: null, path: '', children: [] },
};
const layout = {
    namespaced: true,
    state: state,
    mutations: {
        saveUser(state: LayoutStateVOI, data) {
            state.userInfo = data;
        },
        saveCache(state: LayoutStateVOI, data) {
            state.cache = data;
        },
        saveCurrentPageMenus(state: LayoutStateVOI, data) {
            state.currentPageMenu = data;
        },
    },
};

export default layout;

function detectionMenus(type) {
    return [
        {
            title: '站点监测',
            path: 'gis/index',
            id: 1,
            children: [
                {
                    title: '站点监测', //主页list
                    id: 1,
                    path: '/' + type + '/detection/station/list',
                },
                {
                    title: '数据查看',
                    id: 1,
                    path: '/' + type + '/detection/station/detail',
                },
                {
                    title: '趋势管理',
                    id: 1,
                    path: '/' + type + '/detection/station/trendsManage',
                },
                {
                    title: '状态参数',
                    id: 1,
                    path: '/' + type + '/detection/station/stateParameter',
                },
                {
                    title: '运行日志',
                    id: 1,
                    path: '/' + type + '/detection/station/runLog',
                },
                {
                    title: '报警日志',
                    id: 1,
                    path: '/' + type + '/detection/station/alarmLog',
                },
                {
                    title: '参数日志',
                    id: 1,
                    path: '/' + type + '/detection/station/parameterLog',
                },
                {
                    title: '视频监控',
                    id: 1,
                    path: '/' + type + '/detection/station/video',
                },
                {
                    title: '设备反控',
                    id: 1,
                    path: '/' + type + '/detection/station/deviceCounter',
                },
                {
                    title: '设备详情',
                    id: 1,
                    path: '/' + type + '/detection/station/deviceDetail',
                },
            ],
        },
        {
            title: '数据管理',
            path: 'gis/index',
            id: 1,
            children: [
                {
                    title: '数据查看',
                    id: 1,
                    path: '/' + type + '/dataManage/dataView/list',
                },
                {
                    title: '单站点数据',
                    id: 1,
                    path: '/' + type + '/dataManage/dataView/detail',
                },
                {
                    title: '数据审核',
                    path: '/' + type + '/dataManage/dataAudit/index',
                    id: 1,
                },
                {
                    title: '数据补遗',
                    path: '/' + type + '/dataManage/dataComplete/index',
                    id: 1,
                },
            ],
        },
        {
            title: '报警管理',
            path: 'gis/index',
            id: 1,
            children: [
                {
                    title: '报警查询',
                    id: 1,
                    path: '/' + type + '/alarmManage/alarmSearch/index',
                },
                {
                    title: '报警统计',
                    path: '/' + type + '/alarmManage/alarmStatistics/index',
                    id: 1,
                },
            ],
        },
        {
            title: '分析报表',
            id: 1,
            path: 'gis/index',
            children: [
                {
                    title: '趋势分析',
                    id: 1,
                    path: '/' + type + '/reportManage/tendencyAnalyse/index',
                },
                {
                    title: '单站点报表',
                    path: '/' + type + '/reportManage/singleStationReport/index',
                    id: 1,
                },
                {
                    title: '综合报表',
                    path: '/' + type + '/reportManage/synthesizeReport/index',
                    id: 1,
                },
            ],
        },
        {
            title: '监控列表',
            path: '/' + type + '/sysconfig/diskConfig/index',
            id: 1,
        },
        {
            // title: '报警列表',
            title: '球机报警',
            path: '/' + type + '/alarms/alarm/index',
            id: 1,
        },
        {
            title: '资料管理',
            path: '/' + type + '/data/management/index',
            id: 1,
        },
    ];
}


//地表水单列菜单
function detectionMenusDbs(type) {
    return [
        {
            title: '站点监测',
            path: 'gis/index',
            id: 1,
            children: [
                {
                    title: '站点监测', //主页list
                    id: 1,
                    path: '/' + type + '/detection/station/list',
                },
                {
                    title: '数据查看',
                    id: 1,
                    path: '/' + type + '/detection/station/detail',
                },
                {
                    title: '趋势管理',
                    id: 1,
                    path: '/' + type + '/detection/station/trendsManage',
                },
                {
                    title: '状态参数',
                    id: 1,
                    path: '/' + type + '/detection/station/stateParameter',
                },
                {
                    title: '运行日志',
                    id: 1,
                    path: '/' + type + '/detection/station/runLog',
                },
                {
                    title: '报警日志',
                    id: 1,
                    path: '/' + type + '/detection/station/alarmLog',
                },
                {
                    title: '参数日志',
                    id: 1,
                    path: '/' + type + '/detection/station/parameterLog',
                },
                {
                    title: '视频监控',
                    id: 1,
                    path: '/' + type + '/detection/station/video',
                },
                {
                    title: '设备反控',
                    id: 1,
                    path: '/' + type + '/detection/station/deviceCounter',
                },
                {
                    title: '设备详情',
                    id: 1,
                    path: '/' + type + '/detection/station/deviceDetail',
                },
                {
                    title: '报警上下限',
                    id: 1,
                    path: '/' + type + '/detection/station/alarmupper',
                },
            ],
        },
        {
            title: '数据管理',
            path: 'gis/index',
            id: 1,
            children: [
                {
                    title: '数据查看',
                    id: 1,
                    path: '/' + type + '/dataManage/dataView/list',
                },
                {
                    title: '单站点数据',
                    id: 1,
                    path: '/' + type + '/dataManage/dataView/detail',
                },
                {
                    title: '数据审核',
                    path: '/' + type + '/dataManage/dataAudit/index',
                    id: 1,
                },
                {
                    title: '数据补遗',
                    path: '/' + type + '/dataManage/dataComplete/index',
                    id: 1,
                },
            ],
        },
        {
            title: '报警管理',
            path: 'gis/index',
            id: 1,
            children: [
                {
                    title: '报警查询',
                    id: 1,
                    path: '/' + type + '/alarmManage/alarmSearch/index',
                },
                {
                    title: '报警统计',
                    path: '/' + type + '/alarmManage/alarmStatistics/index',
                    id: 1,
                },
            ],
        },
        {
            title: '分析报表',
            id: 1,
            path: 'gis/index',
            children: [
                {
                    title: '趋势分析',
                    id: 1,
                    path: '/' + type + '/reportManage/tendencyAnalyse/index',
                },
                {
                    title: '单站点报表',
                    path: '/' + type + '/reportManage/singleStationReport/index',
                    id: 1,
                },
                {
                    title: '综合报表',
                    path: '/' + type + '/reportManage/synthesizeReport/index',
                    id: 1,
                },
            ],
        },
        {
            title: '监控列表',
            path: '/' + type + '/sysconfig/diskConfig/index',
            id: 1,
        },
        {
            // title: '报警列表',
            title: '球机报警',
            path: '/' + type + '/alarms/alarm/index',
            id: 1,
        },
        {
            title: '资料管理',
            path: '/' + type + '/data/management/index',
            id: 1,
        },
    ];
}

